<div class="filter-sort-form" *ngIf="model">
  <div class="d-flex flex-wrap justify-content-between">
    <rr-text-field
      [(ngModel)]="model.filterBy.value"
      [settings]="textFieldModel"
      [minlength]="3"
      [customErrorMessages]="customErrorMessagesText"
      (change)="changeInputFilter()"
      (clearInput)="setDefaultValues()"
      (input)="changeInputFilter()"
    >
    </rr-text-field>
  </div>
</div>
